module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_TypesBox.a1c4872c.png";